import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Static imports of translation files
import enCommon from "./locales/en/common.json";
import enNav from "./locales/en/nav.json";
import enAuth from "./locales/en/auth.json";
import enProject from "./locales/en/project.json";
import enBilling from "./locales/en/billing.json";
import enAnalytics from "./locales/en/analytics.json";
import enGallery from "./locales/en/gallery.json";
import enProfile from "./locales/en/profile.json";
import enWebhooks from "./locales/en/webhooks.json";

import frCommon from "./locales/fr/common.json";
import frNav from "./locales/fr/nav.json";
import frAuth from "./locales/fr/auth.json";
import frProject from "./locales/fr/project.json";
import frBilling from "./locales/fr/billing.json";
import frAnalytics from "./locales/fr/analytics.json";
import frGallery from "./locales/fr/gallery.json";
import frProfile from "./locales/fr/profile.json";
import frWebhooks from "./locales/fr/webhooks.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        nav: enNav,
        auth: enAuth,
        project: enProject,
        billing: enBilling,
        analytics: enAnalytics,
        gallery: enGallery,
        profile: enProfile,
        webhooks: enWebhooks,
      },
      fr: {
        common: frCommon,
        nav: frNav,
        auth: frAuth,
        project: frProject,
        billing: frBilling,
        analytics: frAnalytics,
        gallery: frGallery,
        profile: frProfile,
        webhooks: frWebhooks,
      },
    },
    fallbackLng: "en",
    defaultNS: "common",
    ns: [
      "common",
      "nav",
      "auth",
      "project",
      "billing",
      "analytics",
      "gallery",
      "profile",
      "webhooks",
    ],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
  });

export default i18n;
